import React ,{useEffect, useState} from 'react';
import { styled } from 'styled-components';
//mui 
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton } from '@mui/material';
import imgProduct from "../assets/images/product-photo.png"
import MDButton from '../components/MDButton';
import { useNavigate } from 'react-router-dom';
//images
import imgEmpty from "../assets/images/Group_new.png"
import { connect } from 'react-redux';
import { get_cart, notification_Cart } from '../redux/action';
//api request
import { Helper } from '../tools/helper';
import apiRoutes from '../apiRoutes';
import { SnackbarProvider, useSnackbar } from 'notistack';

//product Style
const ContentProducts = styled.div`
    border:1px solid #e4e4e4;
    border-radius:10px;
    // padding:5px 20px;
    margin:10px 0;
    transition:0.4s;
    &:hover{
        border:1px solid ${props=>props.theme.colors.main.default};   
    }
`
const Content= styled.div`
    display:flex;
`
const ImgPart = styled.div`
    width:30%;
    display:flex;
    align-items:center;
    justify-content:center

`
const Img = styled.img`
    width:100%;
    height:60px;
    object-fit:contain
`
const ContentPart = styled.div`
width:70%;

`
const Title = styled.div`
display:flex;
align-items:center;
font-size:${props => props.theme.typography.Montserrat_Regular_base.fontSize};
font-family:${props => props.theme.typography.Montserrat_Regular_base.fontFamily};
font-weight:600

`
const Category = styled.div`
 color:${props=> props.theme.colors.main.hint};
`
const DivController = styled.div`
    padding:5px 0;
    display:flex;

`
const Price = styled.div`
 color:${props=> props.theme.colors.main.default};
 font-family:${props => props.theme.typography.Montserrat_Regular_base.fontFamily};
 font-weight:700;
 font-size:15px;
 width:20%;
 display:flex;
 align-items:center
`
const Buttons = styled.div`
display:flex;
gap:10px;
padding : 0 5px;
// height:20px;
margin-top:10px;
width:80%;
justify-content:end

`
const Counter = styled.div`
width:100px;
height:30px;
border-radius:20px;
background: #f7f7f7;
display:flex;
justify-content:space-between;
align-items:center;
padding:20px;
color:${props=>props.theme.colors.main.default}


`
const Num = styled.div`
   
    font-size:15px;
    width:20px;
    display:flex;
    justify-content:center
`
const Add = styled.div`
    text-align:center;
    color:${props=> props.theme.colors.main.complemently};
    font-family:${props => props.theme.typography.Montserrat_Regular_base.fontFamily};
    font-weight:700;
    font-size:15px;

`
//order
const OrderContent = styled.div`
    // padding:5px 20px;
`
const OrderDiv = styled.div`
border:1px solid #e4e4e4;
border-radius:10px;
padding:25px;
& ul{
    margin:0;
}
& li{
    display:flex;
    padding:3px 0;
    justify-content:space-between;
    font-family:${props => props.theme.typography.Montserrat_Regular_base.fontFamily};
    font-weight:600;
    font-size:16px;
}
& span{
    color:${props=> props.theme.colors.main.hint};
    font-family:${props => props.theme.typography.Montserrat_Regular_base.fontFamily};
    font-weight:600;
    font-size:14px;
}

`

// empty part 
const Emptydiv = styled.div`
min-height:400px;
padding:20px;
display:flex;
align-items:center;
justify-content:center;

& h2{
    color:${props=> props.theme.colors.main.default};
    font-family:${props => props.theme.typography.Montserrat_Regular_base.fontFamily};
    font-weight:600;
    font-size:20px;
    text-align:center;
}
& h6{
    color:black;
    font-family:${props => props.theme.typography.Montserrat_Regular_base.fontFamily};
    font-weight:500;
    font-size:16px;
    text-align:center;
    margin-bottom:10px;
}
& img{
    object-fit:contain
}

`
function Cart_Product({isFromPage=false,onClose,lang,cart,cart_with_api,cart_number}) {

    const [ num , setNum ] = useState(0)
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar();


    const handleQuantity =async (key,cart_id,quantity,product_id)=>{
        const {response,message} = await Helper.Post({
            url:apiRoutes.checkout.update_cart(cart_id),
            hasToken:true,
            data:key=="min"?{
                quantity:quantity-1,
                product_id:product_id,
            }:{
                quantity:quantity+1,
                product_id:product_id
            }
        })
        if(response){
            // enqueueSnackbar(`successfully update `, {variant:"success"} );
            cart_with_api(response.data)
            localStorage.setItem("number_cart",response.data.products.length)
            // setIsLoading(false)
        }else{
            if(message == "MAX_QTY"){
                enqueueSnackbar(`The Quantity is not available. `,{variant:"error",anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                  }}) 
            }else if(typeof(message) === "string"){
                enqueueSnackbar(message,{variant:"error",anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                  }}) 
            }else{
                Object.keys(message).map((key)=>{
                    enqueueSnackbar(`${key} : ${message[key][0]}`,{variant:"error",anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                      }}) 
                })
            }
           
            // setIsLoading(false)
           
        }
    }
    const handleDelete = async (cart_id)=>{
        const {response,message} = await Helper.Delete({
            url:apiRoutes.checkout.update_cart(cart_id),
            hasToken:true,
        })
        if(response){
            enqueueSnackbar("The Product has been removed.", {variant:"success",anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
              }} );
            cart_with_api(response.data)
            cart_number(response.data.products.length,response.data.products.length!=0?true:false)
            localStorage.setItem("number_cart",response.data.products.length)
            // setIsLoading(false)
        }else{
             if(typeof(message) === "string"){
                enqueueSnackbar('Faild delete',{variant:"error",anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                  }}) 
            }else{
                Object.keys(message).map((key)=>{
                    enqueueSnackbar(`${key} : ${message[key][0]}`,{variant:"error",anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                      }}) 
                })
            }
           
            // setIsLoading(false)
           
        }
    }
    return ( cart.products.length>0 ? <>
    
    {cart.products.slice().reverse().map((e)=>{
        return <ContentProducts key={`Cart_Products_${e.product.name}_${e.id}`}>
        {e.product && <Content>
            <ImgPart>
                <Img src={e.product.photo?e.product.photo :imgProduct} />
            
            </ImgPart>
            <ContentPart>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                    <Title> {e.product.product_translations[lang]?e.product.product_translations[lang].name.substring(15,0)+"..":""}</Title>
                    <IconButton onClick={()=>{handleDelete(e.id)}} sx={{display:"flex",alignItems:"center"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M3 6.28259C2.58579 6.28259 2.25 6.61838 2.25 7.03259C2.25 7.44681 2.58579 7.78259 3 7.78259V6.28259ZM21 7.78259C21.4142 7.78259 21.75 7.44681 21.75 7.03259C21.75 6.61838 21.4142 6.28259 21 6.28259V7.78259ZM5 7.03259V6.28259H4.25V7.03259H5ZM19 7.03259H19.75V6.28259H19V7.03259ZM18.3418 16.8303L19.0624 17.0383L18.3418 16.8303ZM13.724 20.8553L13.8489 21.5949L13.724 20.8553ZM10.276 20.8553L10.401 20.1158L10.401 20.1158L10.276 20.8553ZM10.1183 20.8287L9.9933 21.5682H9.9933L10.1183 20.8287ZM5.65815 16.8303L4.93757 17.0383L5.65815 16.8303ZM13.8817 20.8287L13.7568 20.0892L13.8817 20.8287ZM7.84254 5.48939L8.52333 5.80406L7.84254 5.48939ZM8.81802 4.18112L8.31749 3.62258V3.62258L8.81802 4.18112ZM10.2779 3.30696L10.5389 4.01009L10.2779 3.30696ZM13.7221 3.30696L13.9831 2.60384V2.60384L13.7221 3.30696ZM16.1575 5.48939L16.8383 5.17471L16.1575 5.48939ZM3 7.78259H21V6.28259H3V7.78259ZM13.7568 20.0892L13.599 20.1158L13.8489 21.5949L14.0067 21.5682L13.7568 20.0892ZM10.401 20.1158L10.2432 20.0892L9.9933 21.5682L10.151 21.5949L10.401 20.1158ZM18.25 7.03259V12.1758H19.75V7.03259H18.25ZM5.75 12.1759V7.03259H4.25V12.1759H5.75ZM18.25 12.1758C18.25 13.6806 18.0383 15.1776 17.6212 16.6223L19.0624 17.0383C19.5185 15.4583 19.75 13.8212 19.75 12.1758H18.25ZM13.599 20.1158C12.5404 20.2947 11.4596 20.2947 10.401 20.1158L10.151 21.5949C11.3751 21.8017 12.6248 21.8017 13.8489 21.5949L13.599 20.1158ZM10.2432 20.0892C8.40523 19.7786 6.90157 18.4335 6.37873 16.6223L4.93757 17.0383C5.61878 19.3981 7.58166 21.1607 9.9933 21.5682L10.2432 20.0892ZM6.37873 16.6223C5.9617 15.1776 5.75 13.6806 5.75 12.1759H4.25C4.25 13.8212 4.48148 15.4583 4.93757 17.0383L6.37873 16.6223ZM14.0067 21.5682C16.4183 21.1607 18.3812 19.3981 19.0624 17.0383L17.6212 16.6223C17.0984 18.4335 15.5947 19.7786 13.7568 20.0892L14.0067 21.5682ZM8.25 7.03259C8.25 6.61367 8.34194 6.19649 8.52333 5.80406L7.16175 5.17471C6.89085 5.76079 6.75 6.39238 6.75 7.03259H8.25ZM8.52333 5.80406C8.70487 5.41133 8.97357 5.04881 9.31855 4.73966L8.31749 3.62258C7.82675 4.06235 7.43251 4.58893 7.16175 5.17471L8.52333 5.80406ZM9.31855 4.73966C9.66369 4.43037 10.0778 4.18126 10.5389 4.01009L10.0169 2.60384C9.38616 2.83798 8.80808 3.18295 8.31749 3.62258L9.31855 4.73966ZM10.5389 4.01009C11.0001 3.8389 11.4968 3.75 12 3.75V2.25C11.3213 2.25 10.6477 2.36972 10.0169 2.60384L10.5389 4.01009ZM12 3.75C12.5032 3.75 12.9999 3.8389 13.4611 4.01009L13.9831 2.60384C13.3523 2.36972 12.6787 2.25 12 2.25V3.75ZM13.4611 4.01009C13.9222 4.18126 14.3363 4.43037 14.6815 4.73966L15.6825 3.62258C15.1919 3.18295 14.6138 2.83798 13.9831 2.60384L13.4611 4.01009ZM14.6815 4.73966C15.0264 5.04881 15.2951 5.41133 15.4767 5.80407L16.8383 5.17471C16.5675 4.58893 16.1733 4.06235 15.6825 3.62258L14.6815 4.73966ZM15.4767 5.80406C15.6581 6.19649 15.75 6.61367 15.75 7.03259H17.25C17.25 6.39238 17.1092 5.7608 16.8383 5.17471L15.4767 5.80406ZM5 7.78259H19V6.28259H5V7.78259Z" fill="#BE0D0D"/>
                    <path d="M10 12V16M14 12V16" stroke="#BE0D0D" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    </IconButton>
                </div>
                
                <Category>
                {e.product.category_translations[lang]?e.product.category_translations[lang].name.substring(15,0)+"..":""}
                </Category>
                <DivController>
                    <Price>
                        {e.product.sellprice}
                    </Price>
                    <Buttons>
                        <Counter style={{justifyContent:"center"}}>
                            {/* <IconButton sx={{position:"relative",lineHeight:"0",color:"#d80621"}} onClick={()=>{
                               handleQuantity("min",e.id,e.quantity,e.product_id)
                            }} >
                                <span style={{position:"absolute",top:"30%",right:"30%"}}>-</span>
                            </IconButton> */}
                            <Num >
                                {e.quantity}
                            </Num>
                            {/* <IconButton
                             onClick={()=>{
                                handleQuantity("plus",e.id,e.quantity,e.product_id)
                                }}
                                sx={{position:"relative",lineHeight:"0",color:"#d80621"}}    >
                                <span style={{position:"absolute",top:"30%",right:"0%"}}>+</span>
                            </IconButton> */}
    
                        </Counter>
                    </Buttons>
                </DivController>

            </ContentPart>

        </Content>}

    </ContentProducts>
   

    })}
     {!isFromPage && <OrderContent>
    <h3 style={{
        fontFamily:"Montserrat",
        fontSize:"16px"
    }}>Order summary</h3>
    <OrderDiv>
        <ul>
            <li>
                <h5>Subtotal</h5>
                <span>{cart.subtotal}</span>
            </li>
            <li>
                <h5>Tax</h5>
                <span>{cart.tax}</span>
            </li>
            {/* <li>
                <h5>Shipping</h5>
                <span>{cart.shipping}</span>
            </li> */}
            <li>
                <h5>Discount</h5>
                <span>{cart.discounts}</span>
            </li>
        </ul>
        <hr/>
        <ul>
            <li>
                <h5>Total</h5>
                <span>{cart.total}</span>
            </li>
        </ul>
        
        
    </OrderDiv>
</OrderContent>}
    </> :<Emptydiv>
        <div>
            <div style={{display:"flex",justifyContent:"center"}}>
                <img src={imgEmpty} />
            </div>
            <h2>No Products</h2>
            {localStorage.hasOwnProperty("user")?<h6>
                You haven’t added any products yet
            </h6>:<div>
                <h6>
                    You have to regiset or login first
                </h6>
                <div>
                    <MDButton onClick={()=>{
                        onClose()
                        navigate("/autherization")
                        }} content={"login"}/>
                </div>

            </div>
                
            }
        </div>

    </Emptydiv>);
}
const mapStateToProps = (state)=>{
    return{
        cart: state.cart,
        lang: state.lang
    }
}
const mapDispatchToState = (dispatch)=>{
    return{
        cart_with_api: (cart)=>{dispatch(get_cart(cart))},
        cart_number:(num,isOpen)=>{dispatch(notification_Cart(num,isOpen))}
    }
}
export default connect(mapStateToProps,mapDispatchToState)(Cart_Product);